module.exports = __webpack_public_path__ + "static/media/SiloVirtual.c8b52bda.png";